import {nodeId, userStatus, cartStatus, paymentStatus, purchaseStatus, bookType, sellRanking, qaStatus,regStatus} from './config.js'
import 'url-search-params-polyfill';

export default {
  getUrlParams: function (name) {
    let uri = window.location.search.substring(1)
    let params = new URLSearchParams(uri)
    return params.get(name)
    // console.log(params.get("var_name"))
  },
  fetchByParsingUrl: function (res) {
    const pathname = document.location.pathname
    const pageNodeId = document.getElementById('root-class') ? nodeId[document.getElementById('root-class').textContent] : 0
    // console.log(`pageNodeId: ${pageNodeId}`)
    this.getSearchHot()
    this.checkNotify()
    this.getCities()
    this.checkAdblock()
    switch (pathname) {
      case '/':
      case '/index':
        this.pageKey = 'index'
        this.runHomeFlow(pageNodeId, this.pageKey)
        this.getSellRanking(1).then(response => {
          this.serialsSellRanking = response.data.RankingSet[0]
          this.sellRankings['serials'].data = response.data.RankingSet[0]
          this.sellRankings['serials'].display = true
          this.sellRankings['serials'].IsSerial = true //0918火力新增
        })
        this.getSellRanking(2).then(response => {
          this.serialsSellRanking = response.data.RankingSet[0]
          this.sellRankings['comicbook'].data = response.data.RankingSet[0]
          this.sellRankings['comicbook'].display = true
          this.sellRankings['comicbook'].IsSerial = false //0918火力新增
        })
        //0917新增--Fa
        this.getAllTag()
        return false
      case '/serials':
        this.pageKey = 'serials'
        this.runHomeFlow(pageNodeId, this.pageKey)
        this.getSellRanking(1).then(response => {
          this.serialsSellRanking = response.data.RankingSet[0]
          this.sellRankings[this.pageKey].data = response.data.RankingSet[0]
          this.sellRankings[this.pageKey].display = true
          this.sellRankings[this.pageKey].IsSerial = true //0918火力新增
        })
        //0103新增--Fa
        this.getAllTag()
        return false
      case '/comicbook':
        this.pageKey = 'comicbook'
        this.runHomeFlow(pageNodeId, this.pageKey)
        this.getSellRanking(2).then(response => {
          this.comicSellRanking = response.data.RankingSet[0]
          this.sellRankings[this.pageKey].data = response.data.RankingSet[0]
          this.sellRankings[this.pageKey].display = true
          this.sellRankings[this.pageKey].IsSerial = false //0918火力新增
        })
        //0103新增--Fa
        this.getAllTag()
        return false
      case '/novel':
        this.pageKey = 'novel'
        this.runHomeFlow(pageNodeId, this.pageKey)
        return false
      case '/leaderboard':
        this.getSellRanking(this.getUrlParams('id')).then(response => {
          this.sellRanking = response.data
        })
        return false
      // case '/comicbook_info':
      // case '/serials_info':
      // case '/novel_info':
      case '/book':
        var bookId = this.getUrlParams('id')
        //測試 20190912 Fa
        var isGroup = this.getUrlParams("isGroup")
        var isSerials = this.getUrlParams("isSerials")
        //如果是套書
        if(isGroup==="true"){
          this.getBookGroup(bookId,isSerials).then(response => {
            this.showSerialsBook = response.data.IsSerial
            //根據連載或單行顯示集數類別
            if (isSerials === "true") {
              this.getEpisodeOfSerials(response.data.BookGroupID, response.data.BookID)
            } else {
              this.getEpisodeOfBook(response.data.BookGroupID, response.data.BookID)
            }
            // document.getElementById("bookIntroduction").innerHTML = this.book.Introduction
            this.getCommentList(response.data.BookGroupID, response.data.BookID, 4, 1)
            this.getRecommendBookGroup(response.data.BookGroupID)
            this.getNewsListByType()
            response.data.Authors.map((thisAuthor,index) => {
              this.getAuthor(thisAuthor.ID,index)
            })
            this.getTags(response.data.BookGroupID)
          })
        }else{
          this.getBook(bookId).then(response => {
            //0918火力修改 + 0919 Fa
            this.showSerialsBook = response.data.IsSerial
            //根據連載或單行顯示集數類別
            if (!this.showSerialsBook) {
              this.getEpisodeOfBook(response.data.BookGroupID, response.data.BookID)
            } else {
              this.getEpisodeOfSerials(response.data.BookGroupID, response.data.BookID)
            }
            // document.getElementById("bookIntroduction").innerHTML = this.book.Introduction
            this.getCommentList(response.data.BookGroupID, response.data.BookID, 4, 1)
            this.getRecommendBookGroup(response.data.BookGroupID)
            this.getNewsListByType()
            response.data.Authors.map((thisAuthor,index) => {
              this.getAuthor(thisAuthor.ID,index)
            })
            this.getTags(response.data.BookGroupID)
          })
        }
        // this.getEpisodeOfBook()
        // this.getSellShelf(1)
        // this.getBookGroup()
        // 無回應
        // this.getCommentList()
        return false
      case '/book_list':
        var type = ""
        var currentPage = this.getUrlParams('page')
        currentPage? "":currentPage=1
        var pageSize = 20
        this.getSellShelfMore(this.getUrlParams('id'),currentPage,pageSize).then(response =>{
          setPage(response)
        })
        this.listName = this.getUrlParams('name')
        switch(this.getUrlParams('type')){
          case "serials":
          type = "連載 / "
          break;
          case "comicbook":
          type = "漫畫 / "
          break;
        }
        this.breadcrumbs = `<a href="/">首頁</a> / ${type}<a>${this.listName}</a>`
        return false
      case '/news':
        this.getNewsSliderL()
        this.getNewsSliderM()
        this.getNewsListByType()
        this.getSpecialEdit()
        // this.getSliderM() //0918火力新增
        return false
      case '/news_content':
        this.getNewsContent(this.getUrlParams('id'),this.getUrlParams('super'))
        return false
      case '/author':
      case '/author_jp':
        let authorId = this.getUrlParams('id')
        this.getAuthor(authorId).then(response =>{
          $(".author_name").text(response.data.Name)
          this.author = response.data
        })
        this.getAuthorSerials(authorId)
        this.getAuthorCollection(authorId)
        this.getNewsListByType()
        return false
      case '/bookcase':
        // this.getSubscribeList()
        // this.getUserBookGroupList()
        // this.getUserBooks()
        // this.getUserReadingRecords()
        return false
      case '/profile':
      case '/comment_manage':
        var thisItem = this
        this.getCurrentUserInfo().then(function(response){
          console.log("success")
        }).catch(function(e){
          console.log(e.response)
          var r = confirm("請先登入");
          if (r == true) {
            thisItem.redirectTo('/index')
          } else {
            thisItem.redirectTo('/index')
          }
        })
        return false
      case '/cart':
        if(this.checkIsLogin()){
          if (this.confirmCartList.length) {
            this.cartStage = cartStatus.step2
          } else {
            this.cartStage = cartStatus.step1
          }
        }else{
          var r = confirm("請先登入");
          if (r == true) {
            this.redirectTo(`/index`)
          } else {
            this.redirectTo(`/index`)
          }
        }
        console.log("cart")
        //0918火力新增
        if (this.getUrlParams('status') && this.getUrlParams('status').indexOf(purchaseStatus.success) !== -1) {
          // console.log("haha")
          this.cartStage = cartStatus.step3
          this.cartFinish = {}
          this.cartFinish.Balance = this.getUrlParams('coin') || 0
        }
        this.getCartList().then(response => {
          this.isEnoughShopping = this.wallet.coin >= this.cartList.TotalPrice
        })
        this.cartStatus = cartStatus
        return false
      case '/payment':
      var thisItem = this
      this.checkUserStatus().then(function(response){
        thisItem.paymentStage = paymentStatus.step1
        thisItem.getDenomination()
        /* 儲值擋二階段驗證 */
        // if(response.data.RegS2){
        //   thisItem.paymentStage = paymentStatus.step1
        //   thisItem.getDenomination()
        // }else{
        //   var r = confirm("請完成第二階段註冊資訊！");
        //   if (r == true) {
        //     window.location.hash = "notice2"
        //   } else {
        //     thisItem.redirectTo(`/index`)
        //   }
        // }
        return false
      }).catch(e => {
        console.log(e)
        var r = confirm("請進行E-mail認證！");
        if (r) {
          window.location.href = '/index'
        } else {
          window.location.href = '/index'
        }
      })
      case '/customer_service':
        this.getQAList()
        //↓0918火力新增
        this.defaultQADisplay = (this.getUrlParams('id')) ? '' : 'e199feaa-71df-46f5-c217-08d5fdd8532d'
        this.qaStatus = qaStatus
        return false
      case '/member':
        return false
      case '/topic':
        this.getSpecialEditItem(this.getUrlParams('id')).then(response => {
          document.getElementById("specialItemBody").innerHTML = this.specialItem.Body
          response.data.BookSetIDs.map(bsid => {
            this.getSpecialEditBookSetItem(bsid)
          })
        })
        this.getNewsListByType()
        return false
      case '/search':
        var searchParams = this.getUrlParams('query')
        //判斷是否為搜尋tag
        if(searchParams.indexOf("searchTag")>=0){
          this.search(searchParams.replace("searchTag","#"))
        }else{
          this.search(searchParams)
        }
        return false
      case '/coin':
      case '/cost_history':
      case '/inbox':
        return false
      case '/ECPay':
        return false
      default:
        // throw Error('Not allowed.')
        return false
    }
  },
  runHomeFlow: function (pageNodeId) {
    this.page = bookType[this.pageKey]
    this.getBanner(pageNodeId)
    this.getSlider(pageNodeId)
    this.getSliderM(pageNodeId)
    this.getSellShelf(pageNodeId)
    this.getSpecialEdit(pageNodeId)
    this.getSellShelfMore(pageNodeId)
    // 回傳 null
    // this.getNewsList()
    this.getNewsListByType()
    // this.getComment()
    // this.getSpecialEditItem()
    // 回傳 null
    this.getSpecialEditBookSetItem()
    sellRanking.map(item => {
      this.getSalesRanking(item, false)
    })
  }
}



// WEBPACK FOOTER //
// ./src/route.js